<div class="animation-container base-platform-font" [ngClass]="{ incorrect: !isCorrect, 'd-none': !isVisible }">
  <div class="circle">
    <lib-icon class="circle-icon" [icon]="isCorrect ? 'check' : 'x'" [size]="12" [bold]="true"></lib-icon>

    <div class="circle-half circle-half--right">
      <div class="circle-whole"></div>
    </div>

    <div class="circle-half circle-half--left">
      <div class="circle-whole"></div>
    </div>
  </div>

  <div class="animation-text">
    {{ (isCorrect ? 'COMMON.well_done' : 'COMMON.incorrect') | translate }}
  </div>
</div>
